import React, {useEffect, useState} from "react";
import {TabsProps} from "antd";

import {HeaderPage, Tabs} from "components/common";
import ListPrescription from "./ListPrescription/ListPrescription";
import PrescriptionDetails from "./PrescriptionDetail/PrescriptionDetails";
import {tabKeys} from "types/enums";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import Allocation from "./Allocation/Allocation";
import {setSiderKey} from "redux/reducer/common";

const MedicineStore: React.FC = () => {
  document.title = "Nhà thuốc";
  const activeKey = useAppSelector(state => state.common.activeTab);
  const dispatch = useAppDispatch();
  const selectedRecord = useAppSelector(
    state => state.medicineStore.selectedRecord
  );
  const itemsInit: TabsProps["items"] = [
    {
      key: tabKeys.MEDICINE_STORE.LIST_PRESCRIPTION,
      label: `Danh sách đơn thuốc`,
      children: <ListPrescription />,
    },
    {
      key: tabKeys.MEDICINE_STORE.PRESCRIPTION_DETAIL,
      label: `Chi tiết đơn thuốc`,
      children: <PrescriptionDetails />,
    },
    {
      key: tabKeys.MEDICINE_STORE.ALLOCATION,
      label: "Cấp phát thuốc",
      children: <Allocation />,
    },
  ];
  useEffect(() => {
    dispatch(setSiderKey("nhaThuoc"));
  }, []);
  useEffect(() => {
    itemsInit[1].disabled = selectedRecord?.id == null;
    setItems([...itemsInit]);
  }, [selectedRecord]);
  const [items, setItems] = useState<TabsProps["items"]>(itemsInit);
  return (
    <div className="medicine-store page">
      <div className="main">
        <Tabs activeKey={activeKey} items={items} />
      </div>
    </div>
  );
};
export default MedicineStore;
